import React, { FC } from 'react';
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { alertListType } from 'features/alerts/types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { conditionCellStyle, conditionHeaderStyle } from './styles';

type Props = {
  alertList: alertListType;
  selectedRow: number | null;
};

const AlertConditionsTable: FC<Props> = ({ alertList, selectedRow }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (selectedRow === null) {
    return (
      <Typography style={{ fontWeight: 'bold', fontSize: '14pt', paddingBottom: '4px' }}>
        {t('pages.alertList.selectAlert')}
      </Typography>
    );
  }

  const data = alertList[selectedRow]?.conditions || [];
  const alertId = alertList[!!selectedRow ? selectedRow : 0]?.id || -1;

  const handleEditButtonClick = () => {
    if (alertId === -1) {
      return;
    }
    const alert = alertList[!!selectedRow ? selectedRow : 0];
    navigate(`/prediction/edit_alert?id=${alert.id}&is_detail=true&is_area=${alert.is_area}`);
  };

  return (
    <>
      <Typography style={{ fontWeight: 'bold', fontSize: '14pt', paddingBottom: '4px' }}>
        {t('pages.alertList.conditionList')}
      </Typography>
      <TableContainer component={Paper} style={{ minWidth: '400px' }}>
        <Table aria-label="editable table">
          {/* ヘッダー部分 */}
          <TableHead>
            <TableRow>
              <TableCell style={conditionHeaderStyle}>{t('pages.alertList.condition')}</TableCell>
              <TableCell style={conditionHeaderStyle}></TableCell>
              <TableCell style={conditionHeaderStyle}>
                {t(`pages.alertList.conditionSetter.notificationMethod`)}
              </TableCell>
              <TableCell style={conditionHeaderStyle}></TableCell>
            </TableRow>
          </TableHead>

          {/* テーブル本体 */}
          <>
            {(data.length < 1 && (
              <Box>
                {' '}
                <TableCell style={conditionCellStyle}>
                  {' '}
                  {t(`pages.alertList.conditionUnregistered`)}
                </TableCell>
              </Box>
            )) || (
              <TableBody>
                {data.map((d, idx) => (
                  <TableRow key={idx}>
                    <TableCell style={conditionCellStyle}>
                      {t(`pages.alertList.conditionSetter.${d.variable}`)}
                    </TableCell>
                    <TableCell style={conditionCellStyle}>
                      <div>
                        {t('pages.alertList.conditionSetter.in')}&nbsp;
                        {String(d.timerange)}
                        {t('pages.alertList.conditionSetter.hours')}
                        {String(d.threshold)}
                        {t('pages.alertList.conditionSetter.cm')}
                      </div>
                    </TableCell>
                    <TableCell style={conditionCellStyle}>
                      {t(`pages.alertList.conditionSetter.${d.notification}`)}
                    </TableCell>
                    <TableCell align="right" style={conditionCellStyle}>
                      <IconButton aria-label="edit" onClick={handleEditButtonClick}>
                        <EditIcon style={{ fontSize: '14pt' }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </>
        </Table>
      </TableContainer>
    </>
  );
};

export default AlertConditionsTable;
